// Module
var code = "<script>let $ctrl</script> <molecule-panel-edit-row-nameserver-list nameservers=\"$ctrl.nameserverList\" domains=\"$ctrl.domains\" glue-record=\"true\"></molecule-panel-edit-row-nameserver-list> ";
// Exports
module.exports = code;